import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = process.env.REACT_APP_ACCESS_KEY || "imgscraper_auth";

export default function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === "granted";
  });
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${API}/auth/verify`, { password });
      if (res.data.valid) {
        localStorage.setItem(STORAGE_KEY, "granted");
        setAuthenticated(true);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Senha incorreta");
      } else {
        setError("Erro ao verificar senha");
      }
    } finally {
      setLoading(false);
    }
  };

  if (authenticated) return children;

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <form onSubmit={handleSubmit} data-testid="password-form">
          <div className="relative">
            <input
              data-testid="password-input"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              placeholder="Digite a senha"
              autoFocus
              className="w-full h-12 px-4 pr-12 bg-[#121214] border border-white/10 rounded-xl text-sm text-white placeholder:text-white/25 outline-none focus:border-[#007AFF]/50 focus:ring-2 focus:ring-[#007AFF]/20 transition-all"
            />
            <button
              type="button"
              data-testid="password-toggle-visibility"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-white/30 hover:text-white/60 transition-colors cursor-pointer"
            >
              {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
            </button>
          </div>

          {error && (
            <p data-testid="password-error" className="text-red-400 text-xs mt-2 ml-1">{error}</p>
          )}

          <button
            data-testid="password-submit"
            type="submit"
            disabled={loading || !password.trim()}
            className="w-full h-11 mt-4 bg-[#007AFF] hover:bg-[#007AFF]/90 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-all cursor-pointer"
          >
            {loading ? "Verificando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
